import React, { ComponentType } from "react";
import styled from "styled-components";
import { CategoryDetail, FunctionDetail, LOVValues, ProgramContainer } from "../../../entities/formTemplateDataType";
import { colour, media, spacing } from '../../../theme';
import { ErrorAlertComponent } from "../../odsCalloutBox/ErrorAlertComponent";
import { Heading1, Heading4 } from "../../../theme/headings";
import { CMAReportComponent } from "./CMAReportComponent";
import ReactModal from "react-modal";
import { InputText } from "primereact/inputtext";
import CMAUtils from "../../../utilities/CMAUtils";
import { ReactComponent as CloseIcon } from '../../../../public/assets/css/ontario-design-system/icons/ontario-icon-close.svg';
import { TemplateStatus } from "../../../entities/Constants";
import { SpinnerComponent } from "../../../commonComponent/SpinnerComponent";


interface Props {
    programContainer: ProgramContainer;
    showCommentStatus: boolean;
    cmaRole: string;
    isEng: boolean;
    callbackStepIndex?: (index: number, returnIndex?:number) => void;
    callback: (p: ProgramContainer) => void;
    callbackValueSaved: ()=>void;
}

interface State {
    showError: boolean;
    showReport: boolean;
    expandedFunctionHint: boolean[];
    expandedCategoryHint: boolean[];
    openApproverNote: boolean;
    openApprovePopup: boolean;
    openRejectPopup: boolean;
    openSuccessPopup: boolean;
    openErrorPopup: boolean;
    openCSDPopup: boolean;
    successMessage: string;
    isBusy: boolean;
    showNameDialog: boolean;
    nameInput: string;
    nameError: string | null;
    isHovered: boolean;
    approvalNoteInput: string | null;
}

const StyledReactModal = styled(ReactModal as ComponentType<ReactModal['props']>)`
    position: fixed;
    top: 50%;
    left: 50%;
    width: 47%;
    height: auto;
    max-height: 90vh;
    max-width: 100vw;
    margin: ${spacing.spacing0};
    transform: translate(-50%, -50%);
    overflow: auto;
    padding: ${spacing.spacing5} ${spacing.spacing4};
    box-shadow: rgba(26, 26, 26, 0.6) 0 0 2px;
    transition: box-shadow 0.1s ease-in-out 0s;

    @media ${media.small} {
        height: auto;
        max-height: 95vh;
        max-width: 95vw;
    }

    @media ${media.medium} {
        padding: ${spacing.spacing7} ${spacing.spacing5};
        max-height: 90vh;
    }

    @media ${media.large} {
        height: auto;
        max-width: 1200px;
    }
    `;

const StyledTableHead = styled.div`
    padding: 18px 16px 18px 24px;
    border-bottom: 3px solid ${colour.systemBlack};

    @media screen and (max-width: ${media.small}) {
        padding-left: 16px;		
    }
    `;

const StyleTableCell = styled.div`
    display: inline-block;
    padding: 19px 16px 19px 24px;
	text-align: left;
    width: 50%;
    `;


export class CMADashboardComponent extends React.Component<Props, State> {
   functions;
   functionNameList: LOVValues[];
    constructor(props) {
        super(props);
        const currentTemplate = this.props.programContainer.Template;
        this.functions = this.props.programContainer.CMATemplateList.filter(t=>t.Name==currentTemplate)[0].Functions;
        this.functionNameList = [];
        this.functions.forEach((f) => {
            const funcNameObj = this.props.programContainer.FunctionNameList.find(fn => fn.code == f.FunctionName);
            if (funcNameObj) {
                this.functionNameList.push(funcNameObj);
            }
        });
        this.state = {
            showError: false,
            showReport: false,
            expandedFunctionHint: this.functions.map(() => false),
            expandedCategoryHint: this.functions.map(() => false),
            openApproverNote: false,
            openApprovePopup: false,
            openRejectPopup: false,
            openSuccessPopup: false,
            openErrorPopup: false,
            openCSDPopup: false,
            successMessage: "",
            showNameDialog: false,
            nameInput: "",
            nameError: null,
            isHovered: false,
            isBusy: false,
            approvalNoteInput: null,
        }
    }

    disableScroll = () => {
        document.body.style.overflow= "hidden"; 
    }

    enableScroll = () => {
        document.body.style.overflow= "auto";
    }

    showChangeNameDialog = () => {
        this.setState({ showNameDialog: true, nameInput: this.props.programContainer.Entity.assessmentName || ""})
    }
 
    cancelNameChange = () => {
        this.setState({ showNameDialog: false, nameInput: "", nameError: null, showError: false});
    }
 
 
    submitNameChange = () => {
        const regex = /^[a-zA-Z0-9-_]+$/;
        const newName = this.state.nameInput;
   
        if (!newName) {
            this.setState({ nameError: 'Name cannot be empty', showError: true });
        }
       
        else if (newName.length > 100) {
            this.setState({ nameError: 'Limit 100 characters', showError: true });
        }
   
        /* else if (!regex.test(newName)) {
            this.setState({ nameError: 'Name must be alphanumeric (with hyphens and underscores permitted).', showError: true });
        } */
        else {
            this.setState({ showNameDialog: false, nameError: null, showError: false });
            this.props.programContainer.Entity.assessmentName = newName;
            CMAUtils.saveCMA(this.props.programContainer, this.props.programContainer.Entity?.status).then((success)=>{
                if(success){
                    this.props.callbackValueSaved();
                }
            });
        }
    }

    reviewPageIndex = 4;

    hintExpansion = (title: string, content: string, index: number, isFuncHeader: boolean) => {
        const isExpanded = isFuncHeader ? this.state.expandedFunctionHint[index] : this.state.expandedCategoryHint[index];

        return(
            <div className="ontario-hint-expander__container ontario-margin-bottom-0-!" key="cma_dashboard_component_expander_button_key">
                <button className="ontario-hint-expander__button" 
                    id="hint-expander-button-id-1" 
                    aria-controls="hint-expander-content-1" 
                    aria-expanded={isExpanded} 
                    data-toggle="ontario-collapse"
                    onClick={() => {
                        if (isFuncHeader) {
                            let newState = this.state.expandedFunctionHint;
                            newState[index] = !isExpanded;
                            this.setState({expandedFunctionHint: newState});
                        } else {
                            let newState = this.state.expandedCategoryHint;
                            newState[index] = !isExpanded;
                            this.setState({expandedCategoryHint: newState});
                        }
                }}
                >
                    {isExpanded && <svg className="ontario-icon" aria-hidden="true" focusable="false" viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
                            <use href="#ontario-icon-chevron-up"></use>
                        </svg>}
                    {!isExpanded && <svg className="ontario-icon" aria-hidden="true" focusable="false" viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
                            <use href="#ontario-icon-chevron-down"></use>
                        </svg>}
                    {title}
                </button>
                <div style={{display: isExpanded ? "block": "none"}} className="ontario-hint-expander__content" id="hint-expander-content-1" aria-labelledby="hint-expander-button-id-1" aria-hidden="true" data-toggle="ontario-expander-content">
                    <div style={{fontSize:"1rem"}}>{content}</div>
                </div>
            </div>
        );
    }
    functionContent = (f: FunctionDetail, index: number, sectionIndex: number) => {
        let htmlString = [];
        let categoryHtml = [];
        f.CategoryDetailList.forEach((c, index) =>{
            let resolvedComments = 0;
            let unresolvedComments = 0;
            if (this.props.programContainer.Entity.comments) {
                resolvedComments = this.props.programContainer.Entity.comments.reduce((acc, comment) => {
                    if (comment.Resolved && comment.func == f.FunctionName && comment.category == c.CategoryName) {
                        return acc+1;
                    } else return acc;
                }, 0);
                unresolvedComments = this.props.programContainer.Entity.comments.reduce((acc, comment) => {
                    const isSameFuncAndCategory = comment.func === f.FunctionName && comment.category === c.CategoryName;
                    const isVisibleUnresolved = !comment.Resolved && isSameFuncAndCategory && comment.role === 'A';
                    return isVisibleUnresolved ? acc + 1 : acc;
                }, 0);
            }
            categoryHtml.push(this.categoryContent(c, index, sectionIndex, unresolvedComments, resolvedComments));
            sectionIndex = sectionIndex + 1;
        });
         const HtmlToReactParser = require('html-to-react').Parser;
        const htmlToReactParser = new HtmlToReactParser();

        const orginalHtml= this.props.isEng ? this.functionNameList[index].richText : this.functionNameList[index].richTextFRA;
        const reactElement = htmlToReactParser.parse(orginalHtml);

        htmlString.push(
            <div className="ontario-table-container ontario-small-12 ontario-medium-12 ontario-large-12" key="cma_dashboard_component_table_container_key">
                <div className="ontario-table-div">
                    <StyledTableHead>
                        { this.props.isEng && <h2 className="ontario-h3">{"Function " + String(index+1) + ": "}{f.FunctionName}</h2>} 
                        { !this.props.isEng && <h2 className="ontario-h3">{"Fonction " + String(index+1) + " : "}{this.functionNameList[index].FRA}</h2> }
                        { this.props.isEng && this.hintExpansion(`What does ${f.FunctionName} mean?`, this.functionNameList[index].description, index, true)}
                        { !this.props.isEng && this.hintExpansion(`Que signifie ${this.functionNameList[index].FRA} ?`, this.functionNameList[index].FRADescription, index, true)}
                    </StyledTableHead>
                    <StyledTableHead>
                        <h3 className="ontario-h6">{this.props.isEng ? "Category" : "Catégorie"}</h3>
                        {this.hintExpansion(this.props.isEng ? "Please rate your organization against each of the following statements." : "Veuillez évaluer votre organisation par rapport à chacune des affirmations suivantes.", reactElement, index, false)}
                    </StyledTableHead>
                
                {categoryHtml}
                </div>
            </div>
        );
        return htmlString;
    }

    categoryContent = (c: CategoryDetail, index: number, sectionIndex: number, unresolvedComments: number, resolvedComments: number) => {
        let statusContent = [];
        let status = this.checkStatus(sectionIndex);
        const categoryTitle = this.props.isEng ? c.CategoryName : (this.props.programContainer.CategoryNameList.find(cat => cat.code == c.CategoryName).FRA);

        const hasUnresolvedComments =
        this.props.showCommentStatus && unresolvedComments > 0;

        if (hasUnresolvedComments) { //If there are unresolved comments
            statusContent.push(
                <span className="ontario-badge ontario-badge--neutral-light ontario-margin-right-48-!">{this.props.isEng ? " PENDING " : " EN ATTENTE "}</span>
            );
        } else if (status == "Not started yet") {
            statusContent.push(
                <span className="ontario-badge ontario-badge--neutral-light ontario-margin-right-48-!">{this.props.isEng ? "NOT STARTED YET" : "NON COMMENCÉ"}</span>
            );
        } else if (status === "Completed" && this.props.showCommentStatus && unresolvedComments === 0 && resolvedComments > 0) { //After the champion has resolved all the comments added by the champion
            statusContent.push(
                <span className="ontario-badge ontario-badge--neutral-light ontario-margin-right-48-!">{this.props.isEng ? "COMPLETED" : "TERMINÉE"}</span>
            );
        } else if (status == "Completed") {
            statusContent.push(
                <span className="ontario-badge ontario-badge--success-heavy ontario-margin-right-48-!">{this.props.isEng ? "COMPLETED" : "TERMINÉE"}</span>
            );
        } else {
            statusContent.push(
                <span className="ontario-badge ontario-badge--default-heavy ontario-margin-right-48-!">{this.props.isEng ? "IN PROGRESS" : "EN COURS"}</span>
            );
        }
        const highlighted = (this.props.showCommentStatus && unresolvedComments > 0) || (!this.props.showCommentStatus && this.state.showError && status != "Completed");


        return(
            <div
                onClick={(e) => {
                    e.preventDefault();
                    this.props.callbackStepIndex(sectionIndex);
                }}
                onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        this.props.callbackStepIndex(sectionIndex);
                    }
                }}
                style={{borderLeft: highlighted ? ("4px solid " + colour.palette.systemRed) : (this.props.showCommentStatus && unresolvedComments == 0 && resolvedComments > 0 ? ("4px solid " + colour.palette.greyscale70) : "4px"), borderBottom: "1px solid #0000004d", cursor: "pointer"}}>

                <StyleTableCell>
                    <a  href={'#' + c.CategoryName.replace(/\s/g, '')} className="ontario-h5" style={{textDecoration: "none", pointerEvents: "none", color: "inherit"}}> 
                        {String(index+1) + ": " + categoryTitle}
                    </a>
                </StyleTableCell>
                <StyleTableCell>
                    {statusContent}
                    {this.props.showCommentStatus && unresolvedComments > 0 && (
                        <span className="ontario-badge ontario-badge--alert-heavy">
                            {this.props.isEng ? `${unresolvedComments} comments` : `${unresolvedComments} commentaires`}
                        </span>
                    )}
                    {this.props.showCommentStatus && unresolvedComments == 0 && resolvedComments > 0 && (
                        <span className="ontario-badge">
                            {this.props.isEng ? `${resolvedComments} resolved comments` : `${resolvedComments} commentaires résolus`}
                        </span>
                    )}
                </StyleTableCell>
            </div>
        );
    }

    checkStatus = (sectionIndex: number) => {
        const currentSec = this.props.programContainer.ListOfFormSections[sectionIndex]
        if (currentSec) {
            const eleList = currentSec.ListOfFormSubSections[0]?.ListOfFormSectionElements;
            let completionCount = 0;
            eleList?.forEach((ele) => {
                if (ele.Value) completionCount = completionCount + 1;
            })
            if (completionCount == 0) {
                return "Not started yet";
            }
            else if (completionCount == eleList.length) {
                return "Completed";
            }
            else {
                return "In progress";
            }
        }
        return null;
    }

    render() {
        const p = this.props.programContainer;
        const unresolvedComments = !p.Entity.comments ? 0 : (p.Entity.comments.reduce((acc, c) => c.Resolved || c.role == 'C' ? acc : (acc+1), 0));
        const { showError, nameInput, nameError, showNameDialog } = this.state;
        const errorStyle = showError ? { border: '1px solid red' } : {};
        let htmlString = [];
        let sectionIndex = this.reviewPageIndex+1;

        if (this.state.showReport) return <CMAReportComponent programContainer={p} isEng={this.props.isEng}
            callback={() => this.setState({showReport: false})} 
            callbackValueSaved={()=>this.props.callbackValueSaved()}/>;

        htmlString.push(<SpinnerComponent isBusy={this.state.isBusy}/>)
        htmlString.push(
            <ErrorAlertComponent 
                bodyMsg={"Complete all sections before you submit your application."} 
                title={"Your assessment is incomplete"} 
                isEng={true} 
                Visible={this.state.showError}/>
        );

        // The back to CMA Hub link goes here
        htmlString.push(
            <div className="ontario-step-indicator">
                <div className="ontario-row">
                    <div className="ontario-columns ontario-small-12">
                        <div className="ontario-step-indicator--with-back-button">
                            <button className="ontario-button ontario-button--tertiary"
                                onClick={() => {
                                    if (this.props.callbackStepIndex) {
                                        this.props.callbackStepIndex(2);
                                    }            
                                }}>
                                <svg className="ontario-icon" aria-hidden="true" focusable="false" viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
                                    <use href="#ontario-icon-chevron-left"></use>
                                </svg>{this.props.isEng ? "Back to CMA HUB" : "Retour au CARREFOUR DES ECM"}
                            </button>
                        </div>
                        <hr />
                    </div>
                </div>
            </div>
        );

        htmlString.push(
            <Heading1 style={{
                fontFamily: 'Raleway, sans-serif',
                marginBottom: "15px",
                width: "70%",      
                borderBottom: "3px solid black",
                marginTop: "10px",
                marginLeft: "1px",
                }}>{this.props.isEng ? "CMA Dashboard" : "Tableau de bord de l’ECM"}</Heading1>
            )
        
        htmlString.push(
            <div className="editable-name" style={{ display: 'flex', flexDirection: 'column', marginBottom: '10px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <span style={{
                fontFamily: 'Raleway, sans-serif',
                fontSize: '1.0rem',
                fontWeight: 'bold' }}>
                {this.props.programContainer.Entity.assessmentName || this.props.programContainer.Entity.template}
            </span>  
                <a
                    href="#NameChange"
                    onClick={(e) => {
                        e.preventDefault();
                        this.showChangeNameDialog();
                    }}
                    style={{
                        fontFamily: 'Raleway, sans-serif',
                        fontSize: "1.0rem",
                        justifyContent: 'flex-start',
                        textDecoration: 'underline',
                        cursor: 'pointer',
                        marginRight: '30%',
                        visibility: this.props.cmaRole == "Assessor" ? "visible" : "hidden",
                     }}
                >
                    {this.props.isEng ? "Change" : "Modifier"}
                </a>
            </div>

                <div style={{
                    width: "70%",        
                    borderBottom: "1px solid #ccc",  
                    marginTop: "15px",
                    marginBottom: "15px",
                    marginLeft: "1px"
                }}>
                </div>


            <div className="fixed-id"
            style={{
                display: "flex",
                flexDirection: "column",
                marginBottom: "10px",
            }}
            >
           
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <span style={{ fontFamily: 'Raleway, sans-serif', fontSize: '1.0rem', fontWeight: 'bold' }}>
                {"Assessment ID: " + this.props.programContainer.Entity.template}
                </span>
            </div>

            <div
                style={{
                width: "70%",
                borderBottom: "1px solid #ccc",
                marginTop: "15px",
                marginBottom: "9px",
                marginLeft: "1px",
                }}
            />
            </div>
            </div>
           
    );


    if (this.state.showNameDialog) {
        htmlString.push(
            <>
                <div style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    backgroundColor: 'rgba(0, 0, 0, 0.5)',
                    zIndex: 1000
                }} onClick={this.cancelNameChange}></div>
   
                <div style={{
                    position: 'fixed',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    backgroundColor: 'white',
                    padding: '20px',
                    borderRadius: '0px',
                    boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
                    zIndex: 1100,
                    width: '550px',
                    height: 'auto',
                    minHeight: '350px',
                    maxHeight: '400px',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '15px',
                }}>
                    <h3 style={{ fontFamily: 'Raleway', marginBottom: '10px', fontSize: '1.2rem', fontWeight: 'bold' }}>{this.props.isEng ? "Change Assessment Name" : "Modifier le nom de l’évaluation"}</h3>
   
                    <div style={{ width: '240px', height: '70px' }}>
                        <label style={{ fontFamily: 'Raleway, sans-serif', fontWeight: 'normal', fontSize: '15px', paddingBottom: '2%', }}>{this.props.isEng ? "Current Name" : "Nom actuel"}</label>
                        <InputText
                            value={this.props.programContainer.Entity.assessmentName || this.props.programContainer.Entity.template}
                            style={{
                                fontFamily: 'Open sans, sans-serif',
                                fontSize: '15px',
                                paddingTop: '10px',
                                paddingBottom: '10px',
                                paddingLeft: '10px',
                                paddingRight: '10px',
                                border: '1px solid #ccc',
                                borderRadius: '5px',
                                backgroundColor: '#f8f8f8',
                                width: '100%',
                                boxSizing: 'border-box',
                                height: '40px',
                                display: 'flex',
                                ...errorStyle
                            }}
                        />
                    </div>

                    <div style={{ width: '240px', height: '70px' }}>
                        <label style={{ fontFamily: 'Raleway, sans-serif', fontWeight: 'normal', fontSize: '15px', paddingBottom: '2%' }}>{this.props.isEng ? "New Name" : "Nouveau nom"}</label>
                        <InputText
                            value={this.state.nameInput}
                            onChange={(e) => {
                                this.setState({
                                    nameInput: e.target.value,
                                    nameError: null,
                                    showError: false,
                                 });
                            }}
                            placeholder={this.props.isEng ? "Input here" : "Entrez ici"}
                            style={{
                                fontFamily: 'Open sans, sans-serif',
                                fontSize: '15px',
                                paddingTop: '10px',
                                paddingBottom: '10px',
                                paddingLeft: '10px',
                                paddingRight: '10px',
                                border: '1px solid #ccc',
                                borderRadius: '5px',
                                backgroundColor: '#f8f8f8',
                                width: '100%',
                                boxSizing: 'border-box',
                                height: '40px',
                                display: 'flex',
                                ...errorStyle
                            }}
                        />
                    </div>


                {nameError && (
                    <div style={{  fontFamily: 'Open sans, sans-serif', color: 'red', marginTop: '3px' }}>
                        {nameError}
                    </div>
                )}

   
                    <div
                    style={{
                        display: 'flex',
                        justifyContent: 'flex-start',
                        alignItems: 'center',
                        marginTop: '10px',
                        paddingTop: '20px',
                        width: '100%',
                        flexDirection: 'row',
                        paddingBottom: '5px'
                        }}>

                    <button className="ontario-button ontario-button--primary"
                        onClick={() => {this.submitNameChange()}}
                        style={{
                            fontFamily: 'Open sans, sans-serif',
                            fontSize: '0.9rem',
                            paddingLeft: '3px',
                            paddingRight: '3px',
                            width: 'auto',
                            maxWidth: '150px',
                            marginRight: '70px'
                        }}
                    > {this.props.isEng ? "Save Changes" : "Enregistrer"} </button>

                        <a href="#" onClick={(e) => {
                            e.preventDefault();
                            this.cancelNameChange();
                        }}
                        style={{
                            fontFamily: 'Open sans, sans-serif',
                            color: '#007bff',
                            textDecoration: 'underline',
                            cursor: 'pointer',
                            marginLeft: '60px',
                            fontSize: '0.9rem',
                            padding: '6px 12px',
                            marginBottom: '20px'
                         }}>
                            {this.props.isEng ? "Cancel and return" : "Annuler"}
                        </a>
                    </div>
                </div>
            </>
        );
    }  
        let displayViewApproverNote = (this.props.cmaRole == "Assessor" && this.props.programContainer.Entity?.status != TemplateStatus.ASSIGNED && this.props.programContainer.Entity?.status != TemplateStatus.IN_PROGRESS)
                                    || (this.props.cmaRole == "CSM Personal")
                                    || (this.props.cmaRole == "CSD Admin")
        htmlString.push(<>
            <ErrorAlertComponent
                bodyMsg="Please make all requested edits before sending the assessment for final review"
                title={`You have ${unresolvedComments} unresolved comments on your file`}
                dismissible={true}
                isEng={true}
                Visible={this.props.showCommentStatus && this.props.cmaRole == 'Assessor' && unresolvedComments > 0}/>
                
                {p.Entity.approvalNotes && (
                    <button className="ontario-button ontario-button--primary" 
                        type="button"
                        style={{display: displayViewApproverNote ? 'inline-block': 'none'}}
                        onClick={()=> this.setState({openApproverNote: true})}
                    >
                        {this.props.isEng ? "View Approver Note" : "Afficher la note"}
                    </button>
                )}
                <button className="ontario-button ontario-button--primary"
                    style={{display:  this.props.cmaRole == 'Approver' ?  'inline-block' : 'none'}}
                    onClick={() => {
                        // check if all questions are complete
                        let allComplete = true;
                        for (let i=this.reviewPageIndex+1; i < p.ListOfFormSections.length; i++ ) {
                            allComplete = allComplete && (this.checkStatus(i) == "Completed"); 
                        }
                        if (allComplete) {
                            this.setState({showError: false, showReport: true});
                        }
                        else this.setState({showError: true});
                        window.scrollTo({ top: 0, behavior: 'smooth' });
                    }}
                    >{this.props.isEng ? "View Report" : "Voir le rapport"}</button>
        </>);


        this.functions.forEach((f, index) => {
            htmlString.push(this.functionContent(f, index, sectionIndex));
            sectionIndex = sectionIndex + f.CategoryDetailList.length;
        })
        // buttons
        htmlString.push(
            <button className="ontario-button ontario-button--primary"
                style={{display: this.props.showCommentStatus && this.props.cmaRole == 'Approver' ? 'none' : 'inline-block'}}
                onClick={() => {
                    // check if all questions are complete
                    let allComplete = true;
                    for (let i=this.reviewPageIndex+1; i < p.ListOfFormSections.length; i++ ) {
                        allComplete = allComplete && (this.checkStatus(i) == "Completed"); 
                    }
                    if (allComplete) {
                        this.setState({showError: false, showReport: true});
                    }
                    else this.setState({showError: true});
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                }}
                >{this.props.isEng ? "View Report" : "Voir le rapport"}</button>
        );

        htmlString.push(
            <button className="ontario-button ontario-button--primary"
                style={{display:  this.props.cmaRole == 'Assessor' && ([TemplateStatus.ASSIGNED, TemplateStatus.IN_PROGRESS, TemplateStatus.REVISION].includes(this.props.programContainer.Entity?.status)) ? 'inline-block' : 'none'}}
                // Disable button if the userRole does not correspond to the status of the template
                disabled={(
                    (this.props.cmaRole === 'Assessor' && this.props.programContainer.Entity?.status === TemplateStatus.APPROVAL_PENDING) || 
                    (this.props.cmaRole === 'Approver' && this.props.programContainer.Entity?.status === TemplateStatus.ASSIGNED) ||
                    (this.props.cmaRole === 'Approver' && this.props.programContainer.Entity?.status === TemplateStatus.IN_PROGRESS) ||
                    (this.props.cmaRole === 'Approver' && this.props.programContainer.Entity?.status === TemplateStatus.REVISION) ||
                    this.props.programContainer.Entity?.status === TemplateStatus.CANCELED
                )}
                onClick={() => {
                    // check if all questions are complete
                    let allComplete = true;
                    for (let i=this.reviewPageIndex+1; i < p.ListOfFormSections.length; i++ ) {
                        allComplete = allComplete && (this.checkStatus(i) == "Completed"); 
                    }
                    if (allComplete) this.props.callbackStepIndex(this.reviewPageIndex);
                    else this.setState({showError: true});
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                }}>{this.props.isEng ? "Preview and Submit Assessment" : "Prévisualiser et soumettre l’évaluation"}</button>
        );

        htmlString.push(
            <button className="ontario-button ontario-button--primary"
                style={{display: this.props.cmaRole == "CSD Admin" && this.props.programContainer.Entity?.status == TemplateStatus.SUBMITTED ? 'inline-block' : 'none'}}
                onClick={() => this.setState({openCSDPopup: true})}>
                {this.props.isEng ? "Close Assessment" : "Fermer l’évaluation"}
            </button>
        );

        htmlString.push(
            <button className="ontario-button ontario-button--primary"
                style={{display: this.props.cmaRole == 'Approver' && this.props.programContainer.Entity?.status == TemplateStatus.APPROVAL_PENDING ? 'inline-block' : 'none'}}
                // Disable button if the userRole does not correspond to the status of the template
                disabled={(
                    (this.props.cmaRole === 'Assessor' && this.props.programContainer.Entity?.status === TemplateStatus.APPROVAL_PENDING) || 
                    (this.props.cmaRole === 'Approver' && this.props.programContainer.Entity?.status === TemplateStatus.ASSIGNED) ||
                    (this.props.cmaRole === 'Approver' && this.props.programContainer.Entity?.status === TemplateStatus.IN_PROGRESS) ||
                    (this.props.cmaRole === 'Approver' && this.props.programContainer.Entity?.status === TemplateStatus.REVISION) ||
                    this.props.programContainer.Entity?.status === TemplateStatus.CANCELED
                )}
                onClick={() => {
                    window.scrollTo({top: 0, behavior: "smooth"});
                    this.setState({ openApprovePopup: true })}}
                >{this.props.isEng ? "Approve" : "Approuver"}</button>
        );

        htmlString.push(
            <button className="ontario-button ontario-button--secondary"
                style={{display: this.props.cmaRole == 'Approver'  && this.props.programContainer.Entity?.status == TemplateStatus.APPROVAL_PENDING ? 'inline-block' : 'none'}}
                // Disable button if the userRole does not correspond to the status of the template
                disabled={(
                    (this.props.cmaRole === 'Assessor' && this.props.programContainer.Entity?.status === TemplateStatus.APPROVAL_PENDING) || 
                    (this.props.cmaRole === 'Approver' && this.props.programContainer.Entity?.status === TemplateStatus.ASSIGNED) ||
                    (this.props.cmaRole === 'Approver' && this.props.programContainer.Entity?.status === TemplateStatus.IN_PROGRESS) ||
                    (this.props.cmaRole === 'Approver' && this.props.programContainer.Entity?.status === TemplateStatus.REVISION) ||
                    this.props.programContainer.Entity?.status === TemplateStatus.CANCELED
                )}
                onClick={() => {
                    window.scrollTo({top:0, behavior:"smooth"});
                    this.setState({ openRejectPopup: true })}}
                >{this.props.isEng ? "Reject" : "Rejeter"}</button>
        );

        const gap = '50%';
        const trans = 'translate(-50%, -50%)';

        // View Approver Note popup (Assessor POV)
        htmlString.push(
            <ReactModal 
                style={{ content: {position: "fixed", top: gap, left: gap, transform: trans, margin: 0,
                    background: colour.palette.systemRedLight,
                    borderTop: "8px solid " + colour.palette.systemRed,
                    overflow: "auto",
                    padding: `${spacing.spacing5}`,
                    transition: "box-shadow 0.1s ease-in-out 0s"
                },
                overlay: {top: "0", backgroundColor: "rgba(0, 0, 0, 0.6)"} }}
                isOpen={this.state.openApproverNote} 
                shouldCloseOnOverlayClick 
                onRequestClose={() => {
                    this.setState({ openApprovePopup: false });
                    this.enableScroll();
                }}
                onAfterOpen={this.disableScroll}
                onAfterClose={this.enableScroll}
            >
                <div style={{ position: 'relative' }}>
                    <button
                        onClick={() => {
                            this.setState({ openApproverNote: false });
                            this.enableScroll();
                        }}
                        style={{
                            position: 'absolute',
                            top: '-8px',
                            right: '-8px',
                            background: 'transparent',
                            border: 'none',
                            fontSize: '24px',
                            cursor: 'pointer',
                            color: colour.palette.systemRed,
                            fontWeight: 'bold',
                            padding: '4px',
                            lineHeight: '1',
                            zIndex: 1
                        }}
                        aria-label="Close"
                    >
                        <CloseIcon/>
                    </button>
                </div>
                <Heading4>Approver Note</Heading4>
                <p>
                    <strong>{p.Entity.approvalNotes}</strong>
                </p>
                <button className="ontario-button ontario-button--secondary ontario-margin-top-40-!" onClick={() => this.setState({ openApproverNote: false })}  >Close</button>
            </ReactModal>
        );

        // Approve popup (Approver POV)
        htmlString.push(
            <StyledReactModal
                isOpen={this.state.openApprovePopup}
                style={{ content: {
                    background: colour.palette.systemLightGreen,
                    borderTop: "8px solid " + colour.palette.systemGreen,
                },
                overlay: {top: "0", backgroundColor: "rgba(0, 0, 0, 0.6)"} }} 
                shouldCloseOnOverlayClick 
                onRequestClose={() => {
                    this.setState({ openApprovePopup: false });
                    this.enableScroll();
                }}
                onAfterOpen={this.disableScroll}
                onAfterClose={this.enableScroll}
            >
                <div style={{ position: 'relative' }}>
                    <button
                        className="message_button modal-close-button"
                        onClick={() => {
                            this.setState({ openApprovePopup: false });
                            this.enableScroll();
                        }}
                        style={{
                            position: 'absolute',
                            top: '-8px',
                            right: '-8px',
                            background: 'transparent',
                            border: 'none',
                            fontSize: '24px',
                            cursor: 'pointer',
                            color: colour.palette.systemGreen,
                            fontWeight: 'bold',
                            padding: '4px',
                            lineHeight: '1',
                            zIndex: 1
                        }}
                        aria-label="Close"
                    >
                        <CloseIcon/>
                    </button>
                </div>

                <Heading4>{this.props.isEng ? "Assessment Approval" : "Approbation de l’évaluation"}</Heading4>
                
                <p>{this.props.isEng ? "By approving this CMA on behalf of your organization, the results become final. Consider the following:" : "L’approbation de cette ECM au nom de votre organisation a pour effet de rendre les résultats définitifs. Considérez ce qui suit :"}</p>
                <ul>
                    <li>
                        <strong>{this.props.isEng ? "Decide on retention of Comments:" : "Décider de conserver les commentaires :"}</strong>
                        {this.props.isEng ? " Choose whether to retain or remove comments  for future referenced." : " choisissez de conserver ou de supprimer les commentaires pour les référencer ultérieurement."}
                    </li>
                    <li>
                        <strong>{this.props.isEng ? "Data release:" : "Communiquer les données :"}</strong> 
                        {this.props.isEng ? " Assessments may be shared with the Ministry of Public and Business Service Delivery and Procurement, Cyber Security Division." : " les évaluations peuvent être communiquées à la Division de la cybersécurité du ministère des Services au public et aux entreprises et de l’Approvisionnement."}
                    </li>
                    <li>
                        <strong>{this.props.isEng ? "No changes after approval:" : "Aucun changement après l’approbation :"}</strong> 
                        {this.props.isEng ? " Once approved, no edits can be made to the assessment or the Approver’s remarks if added below." : " une fois l’évaluation approuvée, aucune modification ne peut être apportée à celle-ci ou aux remarques de la personne responsable de son approbation, si elles ont été ajoutées ci-dessous."}
                    </li>
                </ul>
                <label className="ontario-label" htmlFor="approver-note-input"> 
                    {this.props.isEng ? "Approver's remarks " : "Remarque de la personne responsable de l’approbation "}<span className="ontario-label__flag">{this.props.isEng ? "(optional)" : "(facultatif)"}</span> </label>
                    <ul>
                        <li>{this.props.isEng ? "Remarks entered here will appear on the first page of the CMA Summary Report near the Overall Rating. Consider noting areas of strength, improvement, or next steps." : "Les remarques saisies ici apparaîtront sur la première page du rapport de synthèse de l’ECM, à côté de la cotation globale. Envisagez de souligner les points forts, les améliorations ou les prochaines étapes."}</li>
                    </ul>
                
                <textarea 
                    value={this.state.approvalNoteInput} 
                    className="ontario-input ontario-textarea" 
                    name="approver-note-input" 
                    id="approver-note-input" 
                    placeholder={this.props.isEng ? "Enter remarks here -" : "Inscrire les remarques ici -"}
                    onChange={(e) => {
                        this.setState({approvalNoteInput: e.target.value});
                        this.props.callback(p);
                        }}/>

                <label className="ontario-label">
                    {this.props.isEng ? "Declaration " : "Déclaration "}<span className="ontario-label_flag">{this.props.isEng ? "(required)" : "(obligatoire)"}</span> </label>
                    {this.props.isEng && <p>By clicking <strong>Approve</strong>, you affirm on behalf of your organization that:</p>}
                    {!this.props.isEng && <p>En cliquant sur <strong>Approuver</strong>, vous affirmez, au nom de votre organisation, que :</p>}
                <ul>
                    <li>{this.props.isEng ? "The CMA ratings reflect your organization’s current Cyber Security state based on self-reported data." : "Les cotations de l’ECM reflètent l’état actuel de la cybersécurité de votre organisation sur la base de données autodéclarées."}</li>
                    <li>{this.props.isEng ? "You are authorized and consent to share this assessment and its data with the Chief Information Security Officer, Cyber Security Division, Ministry of Public and Business Service Delivery and Procurement, and/or their delegates." : "Vous avez l’autorisation et consentez à communiquer le présent résumé de l’ECM et ses données à la directrice générale de la sécurité de l’information (DGSI) de la Division de la cybersécurité, au ministère des Services au public et aux entreprises et de l’Approvisionnement, ou à ses délégués."}</li>
                </ul>
                
                <div style={{marginTop: "16px", marginBottom: "0"}}>
                <button className="ontario-button ontario-button--primary" 
                    onClick={() => {
                        p.Entity.approvalNotes = this.state.approvalNoteInput;
                        this.setState({isBusy: true});
                        CMAUtils.saveCMA(p, TemplateStatus.SUBMITTED).then(sendSubmit => {
                            if (sendSubmit) {
                                this.props.callbackValueSaved();
                                this.setState({isBusy: false, openApprovePopup: false, openSuccessPopup: true, successMessage: this.props.isEng ? "Assessment was submitted successfully." : "L'évaluation a été soumise avec succès."})
                            } else {
                                this.setState({isBusy: false, openApprovePopup: false, openErrorPopup: true})
                            }
                        })
                    }}>
                    {this.props.isEng ? "Approve and retain comments" : "Approuver et conserver les commentaires"}</button>
                <button 
                    className="ontario-button ontario-button--secondary ontario-margin-top-40-!" 
                    onClick={() => {
                        p.Entity.comments = null;
                        p.Entity.approvalNotes = this.state.approvalNoteInput;
                        this.setState({isBusy: true});
                        CMAUtils.saveCMA(p, TemplateStatus.SUBMITTED).then(sendSubmit => {
                            if (sendSubmit) {
                                this.props.callbackValueSaved();
                                this.setState({isBusy: false, openApprovePopup: false, openSuccessPopup: true, successMessage: this.props.isEng ? "Assessment was submitted successfully." : "L'évaluation a été soumise avec succès."})
                            } else {
                                this.setState({isBusy: false, openApprovePopup: false, openErrorPopup: true})
                            }
                        });
                    }}>
                    {this.props.isEng ? "Approve without comments" : "Approuver sans commentaire"}
                </button>
                <button className="ontario-button ontario-button--tertiary ontario-margin-top-40-!" onClick={() => this.setState({openApprovePopup: false})}>{this.props.isEng ? "Cancel" : "Annuler"}</button>
                </div>
            </StyledReactModal>
        );

        // Reject popup (Approver POV)
        htmlString.push(
            <StyledReactModal 
                style={{ content: {
                    background: colour.palette.systemRedLight,
                    borderTop: "8px solid " + colour.palette.systemRed,
                },
                overlay: {top: "0", backgroundColor: "rgba(0, 0, 0, 0.6)"} }}
                isOpen={this.state.openRejectPopup} 
                shouldCloseOnOverlayClick 
                onRequestClose={() => { 
                    this.setState({ openRejectPopup: false });
                    this.enableScroll();
                }}
                onAfterOpen={this.disableScroll}
                onAfterClose={this.enableScroll}
            >
                
                <div style={{ position: 'relative' }}>
                    <button
                        onClick={() => {
                            this.setState({ openRejectPopup: false });
                            this.enableScroll();
                        }}
                        style={{
                            position: 'absolute',
                            top: '-8px',
                            right: '-8px',
                            background: 'transparent',
                            border: 'none',
                            fontSize: '24px',
                            cursor: 'pointer',
                            color: colour.palette.systemRed,
                            fontWeight: 'bold',
                            padding: '4px',
                            lineHeight: '1',
                            zIndex: 1
                        }}
                        aria-label="Close"
                    >
                        <CloseIcon/>
                    </button>
                </div>

                <Heading4>{this.props.isEng ? "Return for revision" : "Renvoi pour révision"}</Heading4>
                
                <strong>{this.props.isEng ? "Before returning this assessment please:" : "Avant de renvoyer cette évaluation, veuillez :"}</strong>
                <ul>
                    <li>{this.props.isEng ? "Provide an overall comment for your CMA Assessor(s)." : "Fournir un commentaire général pour la ou les personnes responsables de l'évaluation de l'ECM."}</li>
                    <li>{this.props.isEng ? "Explain why you are sending it for revision." : "Expliquer les motifs du renvoi pour révision."}</li>
                    <li>{this.props.isEng ? "Add more details or feedback if needed." : "Ajouter des détails ou des commentaires, si nécessaire."}</li>
                </ul>
                <strong>{this.props.isEng ? "You may return for revision without a comment, if necessary." : "Vous pouvez procéder au renvoi pour révision sans commentaire, le cas échéant."}</strong>
                <label className="ontario-label" htmlFor="approver-note-input">
                    {this.props.isEng ? "Approver's note" : "Remarque de la personne responsable de l'approbation"} <span className="ontario-label__flag">{this.props.isEng ? "(optional)" : "(facultatif)"}</span>
                </label>
                <textarea 
                    value={p.Entity.approvalNotes} 
                    className="ontario-input ontario-textarea" 
                    name="approver-note-input" 
                    id="approver-note-input" 
                    placeholder={this.props.isEng ? "Adding a note.............." : "Ajouter une remarque ici."}
                    onChange={(e) => {
                        p.Entity.approvalNotes = e.target.value;
                        this.props.callback(p);
                    }}/>
                <div style = {{marginTop: "16px", marginBottom: "0"}}>
                <button className="ontario-button ontario-button--primary ontario-margin-top-40-!" 
                    onClick={() => {
                        this.setState({isBusy: true});
                        CMAUtils.saveCMA(p, TemplateStatus.REVISION)
                            .then(submission => {
                                if (submission) {
                                    this.props.callbackValueSaved();
                                    this.setState({isBusy: false, openRejectPopup: false, openSuccessPopup: true, successMessage: this.props.isEng ? "Your Assessor(s) will be notified, and you will receive a confirmation email shortly." : "La personne responsable de votre approbation en sera informée et vous recevrez un courriel de confirmation dans les plus brefs délais."})
                                } else {
                                    this.setState({isBusy: false, openRejectPopup: false, openErrorPopup: true})
                                }
                            });
                        }}>
                    {this.props.isEng ? "Return for Revision" : "Renvoi pour révision"}</button>
                <button className="ontario-button ontario-button--secondary ontario-margin-top-40-!" onClick={() => this.setState({openRejectPopup: false})}>{this.props.isEng ? "Cancel" : "Annuler"}</button>
            </div>
            </StyledReactModal>
        );

        // Success popup
        htmlString.push(
            <StyledReactModal 
            style={{ content: {position: "fixed", top: gap, left: gap, transform: trans, margin: 0,
                background: colour.palette.systemLightGreen,
                borderTop: "8px solid " + colour.palette.systemGreen,
                overflow: "auto",
                padding: `${spacing.spacing5}`,
                transition: "box-shadow 0.1s ease-in-out 0s"
            },
            overlay: {top: "0", backgroundColor: "rgba(0, 0, 0, 0.6)"} }}
            isOpen={this.state.openSuccessPopup} >
                <Heading4>{this.props.isEng ? "Success" : "Envoi réussi."}</Heading4>
                
                <p>{this.state.successMessage}</p>
                <button className="ontario-button ontario-button--primary ontario-margin-top-40-!" onClick={() => this.props.callbackStepIndex(2)}>{this.props.isEng ? "Close" : "Fermer"}</button>
            </StyledReactModal>
        );

        // Error popup
        htmlString.push(
            <StyledReactModal 
            style={{ content: {position: "fixed", top: gap, left: gap, transform: trans, margin: 0,
                background: colour.palette.systemRedLight,
                borderTop: "8px solid " + colour.palette.systemRed,
                overflow: "auto",
                padding: `${spacing.spacing5}`,
                transition: "box-shadow 0.1s ease-in-out 0s"
            },
            overlay: {top: "0", backgroundColor: "rgba(0, 0, 0, 0.6)"} }}
            isOpen={this.state.openErrorPopup} 
            shouldCloseOnOverlayClick 
            onRequestClose={() => this.setState({ openErrorPopup: false })}>
                <Heading4>There is an error</Heading4>
                
                <p>There was an error. Please try again.</p>
                <button className="ontario-button ontario-button--primary ontario-margin-top-40-!" onClick={() => this.setState({openErrorPopup: false})}>Close</button>
            </StyledReactModal>
        );

        // CSD popup
        htmlString.push(
            <StyledReactModal 
            style={{ content: {
                background: colour.palette.systemLightGreen,
                borderTop: "8px solid " + colour.palette.systemGreen,
            },
            overlay: {top: "0", backgroundColor: "rgba(0, 0, 0, 0.6)"} }}
            isOpen={this.state.openCSDPopup}
            shouldCloseOnOverlayClick 
            onRequestClose={() => this.setState({ openCSDPopup: false })}>                
                <label className="ontario-label" htmlFor="csd-note-input">
                    {this.props.isEng ? "CSD Note (optional)" : "Remarque de la Division de la cybersécurité (facultatif)"}
                </label>
                <textarea 
                    value={p.Entity.csdNotes} 
                    className="ontario-input ontario-textarea" 
                    name="csd-note-input" 
                    id="csd-note-input" 
                    placeholder={this.props.isEng ? "Add a note here." : "Ajouter une remarque ici."}
                    onChange={(e) => {
                        p.Entity.csdNotes = e.target.value;
                        this.props.callback(p);
                        }}
                    />

                <button className="ontario-button ontario-button--primary ontario-margin-top-40-!" 
                    onClick={() => {
                        this.setState({isBusy: true});
                        CMAUtils.saveCMA(p, TemplateStatus.COMPLETED).then(sendSubmit => {
                            if (sendSubmit) {
                                this.props.callbackValueSaved();
                                this.setState({isBusy: false, openCSDPopup: false, openSuccessPopup: true, successMessage: this.props.isEng ? "Assessment has been marked completed." : "L’évaluation est considérée comme terminée."});
                            } else {
                                this.setState({isBusy: false, openCSDPopup: false, openErrorPopup: true})
                            }
                        })
                    }}>
                    {this.props.isEng ? "Mark Completed" : "Terminé"}
                </button>
            </StyledReactModal>
        );
        return htmlString;
    }
}